import React from "react";
import { LangContext } from "../../contexts/LangContext";

const LANGUAGES = [
  { 
    code: "en", 
    name: "English", 
    flag: (
      <svg width="20" height="14" viewBox="0 0 60 40" style={{ borderRadius: 2, flexShrink: 0 }}>
        <rect width="60" height="40" fill="#012169"/>
        <path d="M0 0l60 40M60 0L0 40" stroke="#fff" strokeWidth="6"/>
        <path d="M0 0l60 40M60 0L0 40" stroke="#C8102E" strokeWidth="2"/>
        <rect x="24" y="0" width="12" height="40" fill="#fff"/>
        <rect x="0" y="16" width="60" height="8" fill="#fff"/>
        <rect x="27" y="0" width="6" height="40" fill="#C8102E"/>
        <rect x="0" y="19" width="60" height="2" fill="#C8102E"/>
      </svg>
    )
  },
  { 
    code: "pl", 
    name: "Polski", 
    flag: (
      <svg width="20" height="14" viewBox="0 0 60 40" style={{ borderRadius: 2, flexShrink: 0 }}>
        <rect y="0" width="60" height="20" fill="#fff"/>
        <rect y="20" width="60" height="20" fill="#DC143C"/>
      </svg>
    )
  },
];

function LangDropdown({ variant = "inline" }) {
  const { lang, setLang } = React.useContext(LangContext);
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  const isSidebar = variant === "sidebar";

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  React.useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div
      className={isSidebar ? "sidebar-lang" : "lang-switch-inline"}
      ref={ref}
      style={{ position: "relative" }}
    >
      {isSidebar && <span className="sidebar-lang-label">🌐</span>}

      <button
        className={`lang-btn-current ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
      >
        {current.flag}
        <span>{current.name}</span>
        <span className={`lang-arrow ${open ? "open" : ""}`}>▾</span>
      </button>

      {open && (
        <div className="lang-dropdown">
          {LANGUAGES.map(({ code, name, flag }) => (
            <button
              key={code}
              className={`lang-dropdown-item ${lang === code ? "selected" : ""}`}
              onClick={() => {
                setLang(code);
                setOpen(false);
              }}
            >
              {flag}
              <span>{name}</span>
              {lang === code && <span style={{ marginLeft: "auto", color: "var(--blue)" }}>✓</span>}
            </button>
          ))}
        </div>
      )}

      <style>{`
        .lang-btn-current {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          padding: 6px 10px !important;
          font-family: 'Montserrat', sans-serif !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          background: #fff !important;
          border: 1.5px solid var(--border) !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: 0.15s !important;
          color: var(--dark) !important;
        }
        .lang-btn-current:hover {
          border-color: var(--blue) !important;
        }
        .lang-btn-current.active {
          border-color: var(--blue) !important;
          box-shadow: 0 0 0 3px var(--blue-light) !important;
        }
        .lang-arrow {
          font-size: 10px;
          color: var(--muted);
          transition: transform 0.2s;
          display: inline-block;
        }
        .lang-arrow.open {
          transform: rotate(180deg);
        }
        
        .lang-dropdown {
          position: absolute;
          top: calc(100% + 4px);
          right: 0;
          background: #fff;
          border-radius: 10px;
          border: 1.5px solid var(--border);
          box-shadow: 0 8px 30px rgba(0,0,0,0.12);
          z-index: 200;
          min-width: 170px;
          overflow: hidden;
          padding: 4px;
        }
        .lang-dropdown-item {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 7px 10px;
          border: none;
          background: transparent;
          border-radius: 7px;
          cursor: pointer;
          font-family: 'Montserrat', sans-serif;
          font-size: 12px;
          font-weight: 500;
          color: var(--dark);
          transition: 0.15s;
        }
        .lang-dropdown-item:hover {
          background: var(--blue-light);
        }
        .lang-dropdown-item.selected {
          background: var(--blue-light);
          color: var(--blue);
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

export function LangSwitchInline() {
  return <LangDropdown variant="inline" />;
}

export function LangSwitchSidebar() {
  return <LangDropdown variant="sidebar" />;
}